import { FC } from "react";
import { ClipboardList, Smartphone, Rss } from "lucide-react";

import HomeLinkCard from "src/components/HomeLinkCard/HomeLinkCard";
import useAuth from "src/hooks/useAuth/useAuth";
import UserAdminFilter from "src/containers/UserAdminFilter/UserAdminFilter";

const Home: FC = () => {
	const { user } = useAuth();

	if (!user) return null;

	return (
		<div
			className="mx-auto w-full 2xl:max-w-[1440px]"
			data-testid="appTemplate-home"
		>
			<h2 className="text-3xl xl:text-4xl font-bold mb-10">
				Hi, {user.firstname}!
			</h2>

			<div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
				<UserAdminFilter specificGroup="vendor-sponsor-editors">
					<HomeLinkCard
						contents="In the banner admin you can create and manage a large amount of banner types, ad posts or even create and manage app branding."
						icon={<Smartphone className="h-7 w-7" />}
						name="App"
						path="/vendor-sponsorship/"
						subheading="Banners, posts, app branding."
					/>
				</UserAdminFilter>

				<HomeLinkCard
					contents="In the observation section you can easily create a new form, check region/area/store reports and observe employee."
					icon={<ClipboardList className="h-7 w-7" />}
					name="Observations"
					path="/observations/submissions"
					subheading="Create forms, check reports."
				/>

				<UserAdminFilter specificGroup="vendor-sponsor-editors">
					<HomeLinkCard
						contents="View and download content from the social feed. Filter by #hashtag, date range or view content in chronological order."
						icon={<Rss className="h-7 w-7" />}
						name="Social Feed Content"
						path="/social-feed-content/"
						subheading="Download images and videos"
					/>
				</UserAdminFilter>
			</div>
		</div>
	);
};

export default Home;
